import ServiceEvent from '../../Services/ServiceEvent';
import ServiceArticle from '../../Services/ServiceArticle';
import Service from '../../Services/Service';
import axios from "axios";
import {domain, domain_article} from "@/util/Constants";

const SearchAPI = {
    searchPrograms(data) {
        data.page = data.page ? data.page : 1;
        return ServiceEvent.get(`/search-products/${data.tag}?keyword=${data.keyword}&page=${data.page}&per_page=10`);
    },
    searchArticles(data) {
        data.page = data.page ? data.page : 1;
        return ServiceArticle.get(`/get-all-articles?keyword=${data.keyword}&page=${data.page}&limit=10`);
    },
    searchTagArticles(data) {
        data.page = data.page ? data.page : 1;
        return ServiceArticle.get(`/get-all-articles?tag=${data.keyword}&page=${data.page}&limit=10`);
    },
    searchEbooks(data) {
        data.page = data.page ? data.page : 1;
        return axios({
            url: `${domain_article}/get-all-articles?keyword=${data.keyword}&type_id=2&page=${data.page}&limit=10`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on search ebook\n', e.message);
            return 'Error';
        });
    },
    searchOnlineExhibitions(data) {
        data.page = data.page ? data.page : 1;
        return axios({
            url: `${domain}/resource_center/online_exhibition_by_branch?keyword=${data.keyword}&page=${data.page}&per_page=10`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get all online exhibitions\n', e.message);
            return 'Error';
        });
    }
};
export default SearchAPI
